import { BLOCKS, MARKS, INLINES, Document } from "@contentful/rich-text-types";
import { documentToHtmlString, Options } from "@contentful/rich-text-html-renderer";
import { html, TemplateResult } from "lit";
import { unsafeHTML } from "lit-html/directives/unsafe-html.js";

// Options for rendering Contentful rich text
const getOptions = (className?: string): Options => {
	const options: Options = {
		renderMark: {
			[MARKS.BOLD]: (text: string) => `<strong>${text}</strong>`,
			[MARKS.ITALIC]: (text: string) => `<em>${text}</em>`,
			[MARKS.UNDERLINE]: (text: string) => `<u>${text}</u>`,
		},
		renderNode: {
			[BLOCKS.PARAGRAPH]: (node, next) =>
				`<contentful-paragraph class="${className}">${next(node.content)}</contentful-paragraph>`,
			[BLOCKS.HEADING_1]: (node, next) => `<h1>${next(node.content)}</h1>`,
			[BLOCKS.HEADING_2]: (node, next) => `<h2>${next(node.content)}</h2>`,
			[BLOCKS.HEADING_3]: (node, next) => `<h3>${next(node.content)}</h3>`,
			[BLOCKS.HEADING_4]: (node, next) => `<h4>${next(node.content)}</h4>`,
			[BLOCKS.HEADING_5]: (node, next) => `<h5>${next(node.content)}</h5>`,
			[BLOCKS.HEADING_6]: (node, next) => `<h6>${next(node.content)}</h6>`,
			[BLOCKS.UL_LIST]: (node, next) => `<ul>${next(node.content)}</ul>`,
			[BLOCKS.OL_LIST]: (node, next) => `<ol>${next(node.content)}</ol>`,
			[BLOCKS.LIST_ITEM]: (node, next) => `<li>${next(node.content)}</li>`,
			[BLOCKS.QUOTE]: (node, next) => `<blockquote>${next(node.content)}</blockquote>`,
			[BLOCKS.HR]: () => `<hr />`,
			[INLINES.HYPERLINK]: (node, next) => `<a href="${node.data.uri}">${next(node.content)}</a>`,
		},
	};

	return options;
};

// Function to render rich text
export function renderRichText(document: Document, className?: string): TemplateResult {
	const htmlString = documentToHtmlString(document, getOptions(className));
	return html`${unsafeHTML(htmlString)}`;
}
